import { loadBurstPair, type FlowThemeDefinition } from '../../definition';
import { mountainCardMotion } from './motion';
import { mountainChromeTone } from './palette';

export const mountainTheme: FlowThemeDefinition = {
  id: 'mountain',
  label: 'Mountain',
  description: 'A night climb to a sunrise summit: the view rises through the clouds and a flag is planted at every step. The default.',
  category: 'classic',
  chromeTone: mountainChromeTone,
  swatch: 'linear-gradient(180deg, #212A66 0%, #8673A2 60%, #FFC18A 100%)',
  cardGlass: 'dense',
  cardMotion: mountainCardMotion,
  burstSize: 300,
  softwareFriendly: false,
  loadScene: () => import('./scene').then((module) => module.createMountainScene),
  loadBursts: () => loadBurstPair(import('./burst-step.json'), import('./burst-finale.json')),
};
